import React from "react";
import Feedback from "./components/Feedback";
import "./index.css";

function Feed() {
  return (
    <div className="Feedback">
      <Feedback />
    </div>
  );
}

export default Feed;
